import { cn } from "@wags/ui/ui-utils";
import { TINTED_PANEL_CLASS } from "@/components/shared/tintedPanel";

export type ProviderStat = { value: string; label: string };

export function ProviderStatTiles({
    stats,
    className,
}: {
    stats: ProviderStat[];
    className?: string;
}) {
    if (stats.length === 0) return null;

    return (
        <div className={cn("flex gap-2.5", className)}>
            {stats.map((stat) => (
                <div
                    key={stat.label}
                    className={cn(
                        "flex flex-1 flex-col gap-0.5",
                        TINTED_PANEL_CLASS,
                    )}
                >
                    <p className="text-item-title text-doberman-black">
                        {stat.value}
                    </p>
                    <p className="text-body-small leading-tight text-doberman-black/55">
                        {stat.label}
                    </p>
                </div>
            ))}
        </div>
    );
}
